import {
	Box,
	Chip,
	IconButton,
	Menu,
	MenuItem,
	Paper,
	Stack,
	Tooltip,
	Typography,
	ListItem,
	Divider,
	List,
	Pagination,
	useTheme,
} from "@mui/material";

import { useEffect, useState } from "react";
import useStyles from "./styles";
import {
	SettingsOutlined,
	MoreVert,
	Delete,
	Person,
	OpenInNewOutlined,
	NotInterestedOutlined,
	Launch,
	Check,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ModalEditCadastro from "../../components/modalEditCadastro";

import InternoModalConfirmacaoSaida from "../../components/modalSaindoDaPagina";

import api from "../../services/api";
import DatagridComponent from "../../components/datagridComponent";
import GrupoChip from "../../components/grupoEconomico/GrupoChip";
import TagCliente from "../../components/tagCliente";
import { maskCnpj, maskCPF } from "../../utils/masks";

function usePagination(data, itemsPerPage) {
	const [currentPage, setCurrentPage] = useState(1);
	const maxPage = Math.ceil(data.length / itemsPerPage);

	function currentData() {
		const begin = (currentPage - 1) * itemsPerPage;
		const end = begin + itemsPerPage;
		return data.slice(begin, end);
	}

	function next() {
		setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
	}

	function prev() {
		setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
	}

	function jump(page) {
		const pageNumber = Math.max(1, page);
		setCurrentPage((currentPage) => Math.min(pageNumber, maxPage));
	}

	return { next, prev, jump, currentData, currentPage, maxPage };
}

export default function Home({
	rows = [],
	setRows = () => {},
	setSnackbar = () => {},
	loading = false,
	buscarUsuario = "",
}) {
	// const [buscarUsuario, setBuscarUsuario] = useState("");
	const [windowWith, setWindowWith] = useState(window.innerWidth);
	const [anchorNotificacao, setAnchorNotificacao] = useState(null);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [openDesativacao, setOPenDesativacao] = useState(false);
	const [openEditModal, setOpenEditModal] = useState(false);
	const [statusCliente, setStatusCLiente] = useState(null);
	const [deleteLoad, setDeleteLoad] = useState(false);
	const [selectedRow, setSelectedRow] = useState({});
	const [pendentes, setPendentes] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const [page, setPage] = useState(1);
	const [tagsProduto, setTagsProduto] = useState([]);
	const theme = useTheme();
	const styles = useStyles(theme);
	const navigate = useNavigate();
	const open = Boolean(anchorEl);
	const openNotificacao = Boolean(anchorNotificacao);
	const logs = JSON.parse(localStorage.getItem("logs"));

	// conteudo a ser passado para o modal delete
	// tipos de modal detele 1: error, 2: warn, 3: info, 4: success
	const deleteBody =
		"Se você prosseguir com a operação, o item e todas as informações associadas serão excluídas permanentemente!";
	const confirmDelete = "Excluir";
	const confirmDesativar = "Desativar";
	const desativarBody =
		"Se você prosseguir com a operação, o cliente e seus usuários serão desativados.";

	const status = {
		0: "Ativo",
		1: "Desativado",
	};

	const filteredRows = rows?.filter((row, index) => {
		row.numero = index;

		const statusNome = status[row.status]?.toLowerCase();

		return (
			row.clienteErpId
				?.toLowerCase()
				?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			row.razaoSocial
				?.toLowerCase()
				?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			row.nomeFantasia
				?.toLowerCase()
				?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			row.as?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			statusNome
				?.toLowerCase()
				?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			row.ClientesCadastro?.email
				?.toLowerCase()
				?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			row.grupoEconomicoNome
				?.toLowerCase()
				?.includes(buscarUsuario?.toLowerCase()?.trim()) ||
			row.tagsCliente?.some((tag) =>
				tag?.name?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()?.trim()),
			)
		);
	});

	function removeRow(id) {
		let newArray = [...rows];
		newArray = newArray.filter((row) => row.id !== id);
		setRows(newArray);
	}
	async function handleApiDeleteClientes(id) {
		setDeleteLoad(true);

		try {
			await api.delete("/cliente/dashHome/deleteClient", {
				data: {
					id: id,
					usuarioId: logs?.usuarioId,
					logsLoginId: logs?.id,
				},
			});

			setSnackbar({
				children: "Cliente deletado com sucesso!",
				severity: "success",
			});

			setAnchorEl(null);
			removeRow(id);
			setOpenDeleteModal(false);
		} catch (error) {
			setSnackbar({
				children: "Error: Não foi possivel se conectar ao servidor",
				severity: "error",
			});
		} finally {
			setDeleteLoad(false);
		}
	}

	async function updateStatusCliente(clienteId, status) {
		try {
			const response = await api.post("/update/status/cliente", {
				clienteId,
				status,
			});

			let newArray = rows.map((cliente) => {
				if (cliente?.id === response?.data?.id) {
					return { ...cliente, status: response?.data?.status };
				}
				return cliente;
			});
			setRows(newArray);
		} catch (error) {
			console.error(error);
		} finally {
			setStatusCLiente(null);
			setOPenDesativacao(false);
		}
	}

	// Lista as tags de cliente (tipo 4) - sao as opcoes de produto do menu
	async function buscarTagsProduto() {
		try {
			const response = await api.post("/form/getTags", { type: "4" });
			setTagsProduto(response?.data || []);
		} catch (error) {
			console.error(error);
		}
	}

	// Troca a tag de produto do cliente (lista vazia = sem produto) e atualiza so a linha dele
	async function atualizarProdutoCliente(clienteId, tagIds) {
		try {
			const response = await api.post("/update/tags/cliente", { clienteId, tagIds });
			setRows(
				rows.map((cliente) =>
					cliente?.id === response?.data?.id ? { ...cliente, tagsCliente: response?.data?.tagsCliente } : cliente,
				),
			);
		} catch (error) {
			setSnackbar({
				children: error?.response?.data?.error || "Erro ao atualizar o produto do cliente",
				severity: "error",
			});
		} finally {
			setAnchorEl(null);
		}
	}

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = (selectedRow) => {
		setAnchorEl(null);
		setAnchorNotificacao(null);
		setPendentes([]);
	};

	const PER_PAGE = 10;

	const count = Math.ceil(filteredRows?.length / PER_PAGE);
	const _DATA = usePagination(filteredRows, PER_PAGE);

	const handleChangePage = (e, p) => {
		setPage(p);
		_DATA.jump(p);
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowWith(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);
	}, []);

	// Tags de produto (tags de cliente, tipo 4) oferecidas no menu de acoes
	useEffect(() => {
		buscarTagsProduto();
	}, []);

	function handleUpdatedClient(upDatedClient) {
		let newArray = rows.map((objeto) => {
			if (objeto.id === upDatedClient.id) {
				return upDatedClient;
			}
			return objeto;
		});
		setRows(newArray);
	}

	const linkView = (params) => {
		return (
			<Box sx={styles.launchContainer}>
				<Launch
					size="small"
					sx={styles.launchIcon}
					onClick={() => {
						localStorage.setItem("selectedClient", JSON.stringify(params?.row));
						navigate(`/home/perfil/${params?.row?.id}`);
					}}
				/>
			</Box>
		);
	};

	const columns = [
		{ field: "id", headerName: "ID", width: 100, hide: true },
		{ field: "clienteErpId", headerName: "Código do Cliente", width: 150 },
		{
			field: "razaoSocial",
			headerName: "Razão Social",
			flex: 1,
			renderCell: (params) => {
				return (
					<Typography
						variant="body2"
						sx={{
							cursor: "pointer",
							"&:hover": { textDecoration: "underline" },
						}}
						onClick={() => {
							const clientStorage = {
								interfaceId: "",
								clienteId: params?.row?.id,
								hostId: "",
								selectTime: 5,
								initialDate: "",
								finalDate: "",
							};
							localStorage.setItem("filterData", JSON.stringify(clientStorage));
							navigate(`/home/perfil/servicos/${params?.row?.id}`);
						}}
					>
						{params?.value || params?.row?.razaoSocial}
					</Typography>
				);
			},
		},
		{
			field: "grupoEconomicoNome",
			headerName: "Grupo Econômico",
			flex: 0.9,
			renderCell: (params) => {
				const isGrupo = params?.row?.isGrupoEconomico;
				if (isGrupo) {
					const count = params?.row?.membros?.length || 0;
					return (
						<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
							<GrupoChip label="Grupo" />
							<Typography variant="body2" sx={{ opacity: 0.7, fontSize: 13 }}>
								{count} cliente{count !== 1 ? "s" : ""}
							</Typography>
						</Box>
					);
				}

				const nomeGrupo = params?.row?.grupoEconomicoNome;
				if (!nomeGrupo)
					return (
						<Typography variant="body2" sx={{ opacity: 0.4 }}>
							—
						</Typography>
					);
				return <GrupoChip label={nomeGrupo} />;
			},
		},
		{
			field: "tagsCliente",
			headerName: "Produto",
			flex: 0.6,
			sortable: false,
			renderCell: (params) =>
				params?.row?.tagsCliente?.length ? (
					<Box sx={styles.produtoCell}>
						{params.row.tagsCliente.map((tag) => (
							<TagCliente key={tag?.id} tag={tag} />
						))}
					</Box>
				) : (
					<Typography variant="body2" sx={styles.semProduto}>
						—
					</Typography>
				),
		},
		{
			field: "cnpj",
			headerName: "CNPJ",
			flex: 0.8,
			renderCell: (params) => {
				const val = params.value || params.row.cnpj || params.row.cpfcnpj || "";
				const clean = val.replace(/\D/g, "");
				return clean.length <= 11 ? maskCPF(clean) : maskCnpj(clean);
			},
		},
		{
			field: "status",
			headerName: "Status cliente",
			flex: 0.9,
			renderCell: (params) => {
				const thisRow = params.row;
				return (
					<Chip
						label={thisRow.status === 0 ? "Ativo" : "Desativado"}
						sx={{
							bgcolor:
								thisRow.status === 0
									? "chip.main.completed"
									: "chip.main.pending",
							width: "100px",
							height: "20px",
							color: theme.palette.white.main,
							fontWeight: 600,
						}}
						size="small"
					/>
				);
			},
			valueGetter: (params) => {
				return params * -1;
			},
		},
		{
			field: "actions",
			headerName: "Opções",
			sortable: false,
			flex: 0.2,
			renderCell: (params) => {
				const onClick = (e) => {
					e.stopPropagation();
					const thisRow = params.row;
					setSelectedRow(thisRow);
					setAnchorEl(e.currentTarget);
				};
				return (
					<Box key={params.id}>
						<Tooltip title={"Ações"} id="basic-button" onClick={onClick}>
							<IconButton size="small" sx={{ padding: 0 }}>
								<SettingsOutlined
									sx={{
										color:
											theme.palette.mode === "dark"
												? theme.palette.white.main
												: "grey",
									}}
								/>
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return (
		<Box sx={styles.container}>
			<Paper
				sx={styles.paperDatagrid}
				elevation={theme.palette.mode == "dark" ? 0 : 3}
			>
				<Box sx={styles.boxDataGrid}>
					<Menu
						id="basic-menu"
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						MenuListProps={{
							"aria-labelledby": "basic-button",
						}}
					>
						<MenuItem
							onClick={() => {
								const clientStorage = {
									interfaceId: "",
									clienteId: selectedRow.id,
									hostId: "",
									selectTime: 5,
									initialDate: "",
									finalDate: "",
								};

								localStorage.setItem(
									"filterData",
									JSON.stringify(clientStorage),
								);
								setAnchorEl(null);
								navigate(
									`/home/perfil/${selectedRow.id}`,
									// , {state: { selectedRow },}
								);
							}}
						>
							<Person sx={{ marginRight: "16px" }}></Person> Perfil
						</MenuItem>

						{selectedRow?.status === 0 ? (
							<MenuItem
								onClick={() => {
									setOPenDesativacao(true);
									setStatusCLiente(1);
									setAnchorEl(null);
								}}
							>
								<NotInterestedOutlined sx={{ marginRight: "16px" }} />
								Desativar
							</MenuItem>
						) : (
							<MenuItem
								onClick={() => {
									setAnchorEl(null);
									updateStatusCliente(selectedRow?.id, 0);
								}}
							>
								<NotInterestedOutlined sx={{ marginRight: "16px" }} />
								Ativar
							</MenuItem>
						)}

						{!selectedRow?.isGrupoEconomico && [
							<Divider key="produto-divisor" />,
							<MenuItem key="produto-titulo" disabled sx={styles.menuTituloProduto}>
								Produto
							</MenuItem>,
							...tagsProduto.map((tag) => (
								<MenuItem key={tag?.id} onClick={() => atualizarProdutoCliente(selectedRow?.id, [tag?.id])}>
									<Check
										sx={
											selectedRow?.tagsCliente?.some((atual) => atual?.id === tag?.id)
												? styles.menuIconeMarcado
												: styles.menuIconeVazio
										}
									/>
									{tag?.name}
								</MenuItem>
							)),
							<MenuItem key="produto-nenhum" onClick={() => atualizarProdutoCliente(selectedRow?.id, [])}>
								<Check sx={selectedRow?.tagsCliente?.length ? styles.menuIconeVazio : styles.menuIconeMarcado} />
								Nenhum produto
							</MenuItem>,
							<Divider key="produto-divisor-fim" />,
						]}

						<MenuItem
							onClick={() => {
								setOpenDeleteModal(true);
								setAnchorEl(null);
							}}
							sx={{ color: "error.main" }}
						>
							<Delete sx={{ marginRight: "16px" }}></Delete> Excluir
						</MenuItem>
					</Menu>

					<Menu
						open={openNotificacao}
						anchorEl={anchorNotificacao}
						placement={"bottom-end"}
						onClose={handleClose}
					>
						{Array.isArray(pendentes) &&
							pendentes?.map((pendente, index) => (
								<MenuItem
									sx={styles.menuItensMobile}
									onClick={(e) => {
										e.stopPropagation();
										navigate(pendente?.link);
									}}
									key={`${pendente?.id}-${index}`}
								>
									<Box sx={styles.containerMenuMobile}>
										{pendente?.icon}
										<Divider
											orientation="vertical"
											flexItem
											sx={{ marginRight: "10px" }}
										/>
										<Typography variant="caption" sx={{ width: "100%" }}>
											{pendente?.message}
										</Typography>
									</Box>
									<OpenInNewOutlined
										fontSize="small"
										sx={{ marginLeft: "10px" }}
									/>
								</MenuItem>
							))}
					</Menu>

					{windowWith < 640 ? (
						<Box>
							<List sx={styles.listContentMobile}>
								<Divider component="li" />
								{Array.isArray(filteredRows) &&
									_DATA.currentData().map((row, index) => (
										<Box key={index}>
											<ListItem sx={styles.listItens}>
												<Box sx={styles.containerListItens}>
													<Box sx={styles.containerNameRazaoSocial}>
														<Typography
															sx={styles.nomeFantasia}
															variant="mySubtitle"
														>
															{row?.nomeFantasia || row?.razaoSocial || ""}
														</Typography>
													</Box>

													<Box>
														<Typography
															sx={{ opacity: "0.8" }}
															variant="caption"
														>
															ASN:
														</Typography>
														<Typography variant="caption">{row?.as}</Typography>
													</Box>
													<Box>
														<Typography
															sx={{ opacity: "0.8" }}
															variant="caption"
														>
															E-mail:
														</Typography>
														<Typography variant="caption">
															{row?.email
																? row?.email
																: row?.ClientesCadastro?.email || ""}
														</Typography>
													</Box>
													<Chip
														label={row?.status === 0 ? "Ativo" : "Desativado"}
														size="medium"
														sx={{
															...styles.chip,
															bgcolor:
																row?.status === 0
																	? "chip.main.completed"
																	: "chip.main.pending",
															fontWeight: 600,
														}}
													/>
												</Box>

												<IconButton
													sx={styles.iconButton}
													onClick={(e) => {
														setSelectedRow(row);
														handleClick(e);
													}}
												>
													<MoreVert />
												</IconButton>
											</ListItem>
											<Divider component="li" />
										</Box>
									))}
							</List>
							<Box sx={{ display: "flex", marginTop: "10px" }}>
								<Stack sx={{ margin: "auto" }} spacing={2}>
									<Pagination
										count={count}
										page={page}
										onChange={handleChangePage}
									/>
								</Stack>
							</Box>
						</Box>
					) : (
						<Box sx={{ minHeight: "100px" }}>
							<DatagridComponent
								rows={filteredRows}
								columns={columns}
								loading={loading}
								options={{ autoHeight: true }}
								sxDatagrid={{
									"& .MuiDataGrid-row": {
										height: "28px",
									},
								}}
							/>
						</Box>
					)}
				</Box>
			</Paper>
			<ModalEditCadastro
				openEditModal={openEditModal}
				setOpenEditModal={setOpenEditModal}
				selectedRow={selectedRow}
				setSelectedRow={setSelectedRow}
				handleUpdatedClient={handleUpdatedClient}
				setSnackbar={setSnackbar}
			/>
			<InternoModalConfirmacaoSaida
				openConfirmacao={openDeleteModal}
				load={deleteLoad}
				setOpenConfirmacao={setOpenDeleteModal}
				execute={() => {
					handleApiDeleteClientes(selectedRow?.id);
				}}
				severity={"error"}
				title={"Atenção"}
				contentText={deleteBody}
				confirmText={confirmDelete}
			/>
			<InternoModalConfirmacaoSaida
				openConfirmacao={openDesativacao}
				load={deleteLoad}
				setOpenConfirmacao={setOPenDesativacao}
				execute={() => {
					updateStatusCliente(selectedRow?.id, statusCliente);
				}}
				title={"Atenção"}
				severity={"warning"}
				headerText={"Deseja realmente desativar o cadastro?"}
				contentText={desativarBody}
				confirmText={confirmDesativar}
			/>
		</Box>
	);
}
